import { styled } from '@goodfynd/theme';
import { Checkbox } from '@mui/material';

export const StyledDiv = styled('div');

export const StyledImage = styled('img', {
  height: '113px',
  borderRadius: 4,
});

export const StyledCheckBox = styled(Checkbox, {
  '&.MuiCheckbox-root': {
    padding: 0,
  },
});

export const StyledPanel = styled('div', {
  border: '1px solid $Neutral02',
  borderRadius: 8,
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  padding: 24,
  maxWidth: '545px',
  '@sm': {
    maxWidth: 'calc(100vw - 24px)',
  },
});

export const StylePanelHeader = styled('div', {
  display: 'grid',
  gridTemplateColumns: 'auto min-content',
  justifyContent: 'space-between',
  alignContent: 'center',
});

export const StyledSummaryContainer = styled('div', {
  display: 'grid',
  gridTemplateColumns: '50% 50%',
  padding: '16px 0px',
  rowGap: 16,
  columnGap: 8,
  '@sm': {
    gridTemplateColumns: '1fr',
  },
});
